import { castArray, isFunction } from 'lodash/fp';

type AccessorItem<T> = string | ((obj: T) => string);
type Accessor<T> = AccessorItem<T> | AccessorItem<T>[];

export const isMatch =
    <T extends Record<string, string>>(pattern: string, accessors: Accessor<T> = 'name') =>
    (obj: T) => {
        const patternLower = pattern.toLowerCase();
        return castArray(accessors).some((accessor) => {
            const value = isFunction(accessor) ? accessor(obj) : obj[accessor];
            return value?.toLowerCase().includes(patternLower);
        });
    };
